import React from "react";
import { useParams } from "react-router-dom";
import Loader from "../../../../../components/Loader/Loader";
import WorkshopPreview from "../../WorkshopPreview/WorkshopPreview";
import { useGetWorkshopPad } from "../api/useQueries";

const TeacherWorkshopPreview = () => {
    const { workshopId } = useParams<{ workshopId: string }>();
    const getPadsQuery = useGetWorkshopPad(workshopId);

    if (!workshopId || getPadsQuery?.isLoading) return <Loader isLoading />;
    if (getPadsQuery?.isError) return null;

    const workshopPadAssignments = getPadsQuery?.data;

    return <WorkshopPreview collaborativePads={workshopPadAssignments} />;
};
export default TeacherWorkshopPreview;
